import { Button, Modal } from "antd";
import "./deleteModel.scss";

export default function DeleteModel({ isModalOpen, handleOk, handleCancel, title, content, btnContent }: { isModalOpen: boolean, handleOk: () => void, handleCancel: () => void, title: string, content: string, btnContent: string[] }) {

    const footer = (
        <div className="footer">
            <Button className="cancel-button" onClick={handleCancel}>{btnContent[0]}</Button>
            <Button className="delete-button" onClick={handleOk}>{btnContent[1]}</Button>
        </div>
    )

    return (
        <Modal
            title={title}
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={footer}
            className="delete-alert"
            centered
            maskClosable={false}
        >
            <div className="content">
                <p>{content}</p>
            </div>
        </Modal>
    )
}